
import Vue from 'vue';
import flatten from 'lodash/flatten';
import HeaderMenu from './HeaderMenu.vue';
import HeaderBottomEmbed from './HeaderBottomEmbed.vue';
import { BottomNavigationProps, Header, ListData } from '@root/modules/navigation/types/navigation';
import isMobileView from '@root/common/utils/isMobileView';

interface Computed {
  getNavBottomItems: ListData[];
  getNavBottomSettings: BottomNavigationProps | null;
  showRegularBigNavigation: boolean;
  isMobileView: boolean;
}

interface Props {
  navigation: Header;
  hideHeaderMenu: boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  name: 'Header',
  components: {
    HeaderMenu,
    HeaderBottomEmbed,
  },
  props: {
    navigation: {
      type: Object,
      required: true,
    },
    hideHeaderMenu: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    getNavBottomItems() {
      const settings = this.getNavBottomSettings;

      if (settings?.useSitemap && settings?.sitemapRef) {
        const sitemapItems = flatten(this.navigation?.sitemap || []).find((item) => item.name === settings.sitemapRef)?.list;

        return Array.isArray(sitemapItems) ? (sitemapItems as ListData[]) : [];
      }

      return this.navigation?.bottom?.items || [];
    },
    getNavBottomSettings() {
      return this.navigation?.bottom?.settings || null;
    },
    showRegularBigNavigation() {
      const headerType = this.getNavBottomSettings?.type;
      const isHeaderBottomLinks = this.getNavBottomItems && this.getNavBottomItems.length > 0;
      return isHeaderBottomLinks || headerType === 'big' || this.$channelConfig('settings').id === 'fone';
    },
    isMobileView() {
      return isMobileView();
    },
  },
});
